import DetailsView from './details-view';

export default DetailsView;